export default "Poêle à granulés 2026 — Aides MPR + CEE + Flamme Verte 7★ | Solution Éco France";
